import { render, staticRenderFns } from "./PricingOptionTitle.vue?vue&type=template&id=07b528d7&scoped=true&"
import script from "./PricingOptionTitle.vue?vue&type=script&lang=js&"
export * from "./PricingOptionTitle.vue?vue&type=script&lang=js&"
import style0 from "./PricingOptionTitle.vue?vue&type=style&index=0&id=07b528d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b528d7",
  null
  
)

export default component.exports